import type { Group as GroupModel } from '@/adapters/catalogv1.g';

export function extractGroup(model: GroupModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    ref: model.group_ref ?? '',
    name: model.name ?? '',
    description: model.description,
    createdAt: model.created_at ? new Date(model.created_at) : undefined,
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroup = ReturnType<typeof extractGroup>;
